import { Injectable } from '@angular/core';
import { RsTitleStrategy } from '@rs-shared-lib/strategies/rs-title-strategy.service';
import { RouterStateSnapshot } from '@angular/router';
import { BRAND_NAMES } from '@lib/rs-ngx';

@Injectable({ providedIn: 'root' })
export class OrdTitleStrategy extends RsTitleStrategy {
  protected appName = BRAND_NAMES['ORD'];

  public override updateTitle(snapshot: RouterStateSnapshot): void {
    let path = this.buildTitle(snapshot);

    let currentRoute = snapshot.root;

    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
    }

    if (currentRoute.data.resolvedData?.leasingCompanyDossierNumber) {
      path = path.replace(
        snapshot.url.split('/')[2],
        `${currentRoute.data.resolvedData.leasingCompanyDossierNumber}`
      );
    }

    this.title.setTitle(path);
  }

}
